import { useState, useContext } from 'react';
import { CustomTemplateMain } from '../custom-template/CustomTemplateMain';
import GenerateCards from '../generate-cards/GenerateCards.component';
import Styles from '../generate-cards/GenerateCards.style';
import { Button, TextField, InputAdornment, Chip, Box, Link } from '@material-ui/core';
import { PAGE_ID, EVENTS, ACTION_ON } from 'constants/tracker';
import { UserPortalContext } from 'context/appcontext';
import SearchIcon from '@material-ui/icons/Search';
import { FEATURES } from 'helper/basicFeatureFlag';
import { getBaseUrl } from 'helper/utils';
import { trackEventInfo } from 'helper/analytics';
import { colors } from 'theme/color-palette';
import { CDS_LEARN_MORE, LEARN_MORE, GIVE_FEEDBACK, CDS_GIVE_FEEDBACK } from 'constants/constant';
const { DARK_PURPLE } = colors;

const MY_DATASET_HEADER_TEXT = 'My dataset';
const WALMART_DATASET_HEADER_TEXT =
	'Build your customized datasets with your own selection of tables ';
const MY_DATASET_HEADER_DESC_TEXT = 'Walmart dataset';
const WALMART_DATASET_HEADER_DESC_TEXT =
	'Pre-defined datasets with recommended selection of tables';
const DATASET_SEARCH_PLACEHOLDER = 'Search';
const ALL_DATASET = 'All dataset';
const MY_DATASET = 'My dataset';
const SHARED_DATASET = 'Shared with me';
const WALMART_DATASET = 'Walmart dataset';

export const DatasetPanel = ({ setShow, templateData }) => {
	const [visibleDataset, setVisibleDataSet] = useState(ALL_DATASET);
	const [searchDatasetText, setSearchDataset] = useState();

	const portalUserContext = useContext(UserPortalContext);
	const { customerType } = portalUserContext;
	const { SHOW_CUSTOM_DATASET: showCustomDataset } = FEATURES[customerType].TEMPLATE_PAGE;

	return (
		<>
			{showCustomDataset && (
				<>
					<>
						<DatasetFilters
							selectedDataset={visibleDataset}
							setDisplayFilter={setVisibleDataSet}
							searchText={searchDatasetText}
							setSearchText={setSearchDataset}
						/>
					</>
					<>
						{visibleDataset != WALMART_DATASET && (
							<>
								<DatasetSubHeaderComponent
									title={MY_DATASET_HEADER_TEXT}
									titleDesc={WALMART_DATASET_HEADER_TEXT}
									showTagAndLink={true}
								/>
								<CustomTemplateMain
									searchDatasetText={searchDatasetText}
									templateData={templateData} //TODO: only for testing purpose, remove this prop
								/>
							</>
						)}
					</>
				</>
			)}
			<>
				{visibleDataset != MY_DATASET && (
					<>
						<DatasetSubHeaderComponent
							title={MY_DATASET_HEADER_DESC_TEXT}
							titleDesc={WALMART_DATASET_HEADER_DESC_TEXT}
						/>
						<GenerateCards
							setShow={setShow}
							templateData={templateData}
							searchDatasetText={searchDatasetText}
						/>
					</>
				)}
			</>
		</>
	);
};

const DatasetFilters = ({ setDisplayFilter, searchText, setSearchText, selectedDataset }) => {
	const classes = Styles();
	return (
		<div className={classes.gridContainer}>
			<div className={classes.datasetFiltersContainer}>
				<div>
					<Button
						disableRipple
						disableTouchRipple
						className={
							selectedDataset == ALL_DATASET
								? classes.selectedDatasetFilterButtons
								: classes.datasetFilterButtons
						}
						variant="outlined"
						onClick={() => {
							setDisplayFilter(ALL_DATASET);
						}}>
						{ALL_DATASET}
					</Button>
				</div>
				<div>
					<Button
						disableRipple
						disableTouchRipple
						className={
							selectedDataset == MY_DATASET
								? classes.selectedDatasetFilterButtons
								: classes.datasetFilterButtons
						}
						variant="outlined"
						onClick={() => {
							setDisplayFilter(MY_DATASET);
						}}>
						{MY_DATASET}
					</Button>
				</div>
				<div className={classes.datasetFilterButtons} style={{ display: 'none' }}>
					<Button variant="outlined">{SHARED_DATASET}</Button>
				</div>
				<div>
					<Button
						disableRipple
						disableTouchRipple
						className={
							selectedDataset == WALMART_DATASET
								? classes.selectedDatasetFilterButtons
								: classes.datasetFilterButtons
						}
						variant="outlined"
						onClick={() => {
							setDisplayFilter(WALMART_DATASET);
						}}>
						{WALMART_DATASET}
					</Button>
				</div>
				<div style={{ width: '325px' }}>
					<TextField
						label=""
						placeholder={DATASET_SEARCH_PLACEHOLDER}
						variant="outlined"
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SearchIcon />
								</InputAdornment>
							)
						}}
						fullWidth
						size="small"
						value={searchText}
						onChange={(e) => {
							setSearchText(e.currentTarget.value);
						}}
					/>
				</div>
			</div>
			<br />
		</div>
	);
};

const DatasetSubHeaderComponent = ({ title, titleDesc, showTagAndLink }) => {
	const classes = Styles();

	const learnMore = (e) => {
		e.stopPropagation();
		window.open(`${getBaseUrl()}${CDS_LEARN_MORE}`, '_blank', 'noreferrer');
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: ACTION_ON.CUSTOM_DATASET_LEARN_MORE,
			location: PAGE_ID.TEMPLATES
		});
	};

	const onGiveFeedback = (e) => {
		e.stopPropagation();
		window.open(`${getBaseUrl()}${CDS_GIVE_FEEDBACK}`, '_blank', 'noreferrer');
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: ACTION_ON.CUSTOM_DATASET_GIVE_FEEDBACK,
			location: PAGE_ID.TEMPLATES
		});
	};

	return (
		<>
			<div className={classes.gridContainer}>
				<div className={classes.subHeadingTitle}>
					{title} {showTagAndLink && <Chip className={classes.betaBadge} label="BETA" />}
				</div>
				<div className={classes.subHeadingTitleDesc}>
					{titleDesc}
					{showTagAndLink && (
						<Box className={classes.subHeadingLinks}>
							<Link
								onClick={learnMore}
								style={{ textDecoration: 'none', color: DARK_PURPLE, cursor: 'pointer' }}>
								{LEARN_MORE}
							</Link>{' '}
							<Link
								onClick={onGiveFeedback}
								style={{ textDecoration: 'none', color: DARK_PURPLE, cursor: 'pointer' }}>
								{GIVE_FEEDBACK}
							</Link>
						</Box>
					)}
				</div>
				<br />
			</div>
		</>
	);
};
